import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

export default function Contact() {
  const { t } = useLanguage();

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(t('contact.form.send') + ' !');
  };

  return (
    <section className="contact section" id="contact">
      <div className="container">
        <h2 className="section-title">{t('contact.title')}</h2>
        <p className="section-subtitle">{t('contact.subtitle')}</p>
        <div className="contact-wrapper">
          <div className="contact-info">
            <div className="contact-item">
              <div className="contact-item-icon">&#9993;</div>
              <div className="contact-item-text">
                <h4>{t('contact.email')}</h4>
                <p>contact@scaneat.tn</p>
              </div>
            </div>
            <div className="contact-item">
              <div className="contact-item-icon">&#9742;</div>
              <div className="contact-item-text">
                <h4>{t('contact.phone')}</h4>
                <p>+216 27 973 247</p>
              </div>
            </div>
            <div className="contact-item">
              <div className="contact-item-icon">&#9872;</div>
              <div className="contact-item-text">
                <h4>{t('contact.address')}</h4>
                <p>Mourouj 6</p>
              </div>
            </div>
          </div>
          <form className="contact-form" onSubmit={handleSubmit}>
            <input type="text" placeholder={t('contact.form.name')} required />
            <input type="email" placeholder={t('contact.form.email')} required />
            <textarea placeholder={t('contact.form.message')} required />
            <button className="btn-primary" type="submit">
              {t('contact.form.send')}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}
